// extracted by mini-css-extract-plugin
export default {"GiftItem":"GiftItem_GiftItem__y4Pnd","activeGift":"GiftItem_activeGift__3aoYN","GiftImage":"GiftItem_GiftImage__EGP+z","GiftText":"GiftItem_GiftText__fehIu"};